import * as React from 'react';

import TextField from '@material-ui/core/TextField';
import { IProps } from './interfaces';
import styles from './TextInput.module.styl';

class SimpleTextInput extends React.Component<IProps, any> {
  public render() {
    const { disabled, input, meta, title, type, InputProps } = this.props;

    return (
      <div className={styles.root}>
        <TextField
          id={`outlined-with-placeholder-second${input.name}`}
          label={title}
          placeholder={title}
          disabled={disabled}
          margin="normal"
          onChange={input.onChange}
          variant="outlined"
          fullWidth={true}
          value={input.value}
          type={type}
          autoComplete="off"
          InputProps={InputProps}
        />

        {meta.touched && meta.error && (
          <span className={styles.error}>{meta.error}</span>
        )}
      </div>
    );
  }
}

export default SimpleTextInput;
